(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comunidad"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (evento) => {
    const enlace = evento.target.closest('[data-evento-comunidad]');
    if (!enlace) return;
    document.dispatchEvent(
      new CustomEvent('brota:comunidad:clic', { detail: { destino: enlace.href }, bubbles: true })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Estado "rodada" para el modo blanco: con scroll, el header abandona el
     blanco flotante y recupera su esquema. Barato: un listener pasivo. */
  (function () {
    var cab = document.querySelector('.cabecera--superpuesto:not(.cabecera--negativo)');
    if (!cab) return;
    function estado() {
      cab.classList.toggle('cabecera--rodada', window.scrollY > 24);
    }
    estado();
    window.addEventListener('scroll', estado, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-mockup"] && !Shopify.designMode) return;
  try {
    
  /* En iPhone el autoplay del atributo a veces no alcanza (modo de bajo
     consumo, o el navegador espera un play() explícito). Refuerzo: se fuerza
     muted por propiedad (no solo por atributo, que iOS ignora a veces), se
     intenta play() cuando la sección entra en pantalla, y si el sistema lo
     bloquea igual, el primer toque en la página lo destraba. */
  (function () {
    var videos = document.querySelectorAll('.kit-mockup__pantalla video');
    if (!videos.length) return;

    function intentar(v) {
      v.muted = true;
      v.playsInline = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    videos.forEach(function (v) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) intentar(v);
          });
        }, { threshold: 0.25 });
        io.observe(v);
      } else {
        intentar(v);
      }
    });

    document.addEventListener('touchstart', function destrabar() {
      videos.forEach(function (v) { if (v.paused) intentar(v); });
      document.removeEventListener('touchstart', destrabar);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('click', (evento) => {
    const enlace = evento.target.closest('[data-evento-nota-producto]');
    if (!enlace) return;
    document.dispatchEvent(
      new CustomEvent('brota:nota:producto', { detail: { destino: enlace.href }, bubbles: true })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* Los + y − del carrito: cambian la cantidad y mandan el formulario solos,
     así el total se actualiza sin apretar "Actualizar". */
  (function () {
    document.querySelectorAll('[data-stepper]').forEach(function (caja) {
      var input = caja.querySelector('input');
      var form = caja.closest('form');
      function cambiar(delta) {
        var v = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = v;
        if (form) form.submit();
      }
      caja.querySelector('[data-stepper-menos]').addEventListener('click', function () { cambiar(-1); });
      caja.querySelector('[data-stepper-mas]').addEventListener('click', function () { cambiar(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Selección de variante sin recargar: se arma el título a partir de las
     opciones elegidas y se busca la variante que coincide. */
  class FormularioProducto {
    constructor(form) {
      this.form = form;
      this.selects = Array.from(form.querySelectorAll('[data-producto-opcion]'));
      this.campoId = form.querySelector('[data-producto-variante-id]');
      this.boton = form.querySelector('button[name="add"]');

      const datos = document.getElementById('variantes-producto');
      this.variantes = datos ? JSON.parse(datos.textContent) : [];

      this.selects.forEach((select) => {
        select.addEventListener('change', () => this.actualizar());
      });
    }

    actualizar() {
      const elegidas = this.selects.map((select) => select.value);
      const variante = this.variantes.find((v) =>
        v.options.every((opcion, indice) => opcion === elegidas[indice])
      );

      if (!variante) return;

      this.campoId.value = variante.id;

      if (this.boton) {
        this.boton.disabled = !variante.available;
        this.boton.textContent = variante.available
          ? this.boton.dataset.textoDisponible || this.boton.textContent
          : this.boton.dataset.textoAgotado || this.boton.textContent;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variante.id);
      window.history.replaceState({}, '', url);
    }
  }

  function iniciarFormularioProducto() {
    document.querySelectorAll('.producto__form').forEach((form) => {
      if (form.dataset.iniciado) return;
      form.dataset.iniciado = 'true';
      new FormularioProducto(form);
    });
  }

  document.addEventListener('DOMContentLoaded', iniciarFormularioProducto);
  document.addEventListener('shopify:section:load', iniciarFormularioProducto);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquesina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar() {
      document.querySelectorAll('[data-marquesina]').forEach(function (marquesina) {
        if (marquesina.dataset.iniciada) return;
        marquesina.dataset.iniciada = 'true';

        var boton = marquesina.querySelector('[data-marquesina-pausa]');
        if (boton) {
          boton.addEventListener('click', function () {
            var pausada = marquesina.classList.toggle('marquesina--pausada');
            boton.setAttribute('aria-pressed', String(pausada));
          });
        }

        /* Fuera del viewport no hay motivo para seguir animando. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entradas) {
            entradas.forEach(function (entrada) {
              marquesina.classList.toggle('marquesina--fuera', !entrada.isIntersecting);
            });
          }).observe(marquesina);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-necesidad"] && !Shopify.designMode) return;
  try {
    
  class SelectorNecesidad {
    constructor(raiz) {
      this.raiz = raiz;
      this.botones = Array.from(raiz.querySelectorAll('[data-selector-boton]'));
      this.respuestas = Array.from(raiz.querySelectorAll('[data-selector-respuesta]'));
      this.inicioNotificado = false;

      this.botones.forEach((boton) => {
        boton.addEventListener('click', () => this.elegir(boton));
      });

      raiz.querySelectorAll('[data-selector-volver]').forEach((boton) => {
        boton.addEventListener('click', () => this.volver());
      });

      raiz.querySelectorAll('[data-selector-evento]').forEach((enlace) => {
        enlace.addEventListener('click', () => {
          this.emitir('brota:selector:clic', {
            destino: enlace.dataset.selectorEvento,
            necesidad: enlace.dataset.selectorNecesidad,
          });
        });
      });
    }

    /* No se guarda ninguna respuesta: ni en el servidor, ni en localStorage,
       ni en la URL. El estado vive solo en esta vista. */
    elegir(boton) {
      const id = boton.dataset.respuesta;

      if (!this.inicioNotificado) {
        this.inicioNotificado = true;
        this.emitir('brota:selector:inicio', {});
      }

      this.botones.forEach((otro) => {
        otro.setAttribute('aria-expanded', String(otro === boton));
      });

      let elegida = null;
      this.respuestas.forEach((respuesta) => {
        const activa = respuesta.dataset.selectorRespuesta === id;
        respuesta.hidden = !activa;
        if (activa) elegida = respuesta;
      });

      this.emitir('brota:selector:eleccion', {
        necesidad: boton.querySelector('.selector__opcion-texto').textContent.trim(),
      });

      if (elegida) {
        const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        elegida.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'nearest' });
      }
    }

    volver() {
      this.botones.forEach((boton) => boton.setAttribute('aria-expanded', 'false'));
      this.respuestas.forEach((respuesta) => {
        respuesta.hidden = true;
      });

      const primero = this.botones[0];
      if (primero) primero.focus();

      this.emitir('brota:selector:volver', {});
    }

    emitir(nombre, detalle) {
      document.dispatchEvent(new CustomEvent(nombre, { detail: detalle, bubbles: true }));
    }
  }

  function iniciarSelectores() {
    document.querySelectorAll('[data-selector]').forEach((raiz) => {
      if (raiz.dataset.selectorIniciado) return;
      raiz.dataset.selectorIniciado = 'true';
      new SelectorNecesidad(raiz);
    });
  }

  document.addEventListener('DOMContentLoaded', iniciarSelectores);
  document.addEventListener('shopify:section:load', iniciarSelectores);

  } catch(e) { console.error(e); }
})();
})();
